// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Popover__Wrapper_1i4a2"};